import { render, staticRenderFns } from "./BriefShopInfo.vue?vue&type=template&id=3a167f75&scoped=true&"
import script from "./BriefShopInfo.vue?vue&type=script&lang=js&"
export * from "./BriefShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./BriefShopInfo.vue?vue&type=style&index=0&id=3a167f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a167f75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3a167f75', component.options)
    } else {
      api.reload('3a167f75', component.options)
    }
    module.hot.accept("./BriefShopInfo.vue?vue&type=template&id=3a167f75&scoped=true&", function () {
      api.rerender('3a167f75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/BriefShopInfo.vue"
export default component.exports